import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import { CtaBand } from "@/components/site/Cta";
import { SECTORS } from "@/data/sectors";

export default function SectorsIndex() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Soluzioni", to: "/soluzioni" }];
  return (
    <>
      <Seo path="/soluzioni" title="Soluzioni per settore: siti web per ogni attività | STUDIO WEB NS"
        description="Siti web pensati per bar, parrucchieri, negozi di abbigliamento, botteghe, showroom e artigiani. Esigenze, funzionalità e pacchetti per ogni settore." jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow="Soluzioni per attività" title="Ogni settore ha le sue domande. Il tuo sito deve rispondere." intro="Un bar, un salone e uno showroom non hanno bisogno dello stesso sito. Ecco come lavoriamo per ciascun tipo di attività." />
      <section className="py-14 md:py-20">
        <div className="wrap grid gap-6 md:grid-cols-2">
          {SECTORS.map((s, i) => (
            <Link key={s.slug} to={`/soluzioni/${s.slug}`} data-testid={`sector-card-${s.key}`} className={`group relative overflow-hidden rounded-3xl ${i % 3 === 0 ? "md:row-span-1" : ""}`}>
              <img src={s.img} alt={`Esempio ${s.name.toLowerCase()}`} loading={i < 2 ? "eager" : "lazy"} width="800" height="560" className="aspect-[7/5] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-x-3 bottom-3 rounded-2xl border border-white/70 bg-[#EAF4FF]/90 p-5 backdrop-blur-md sm:inset-x-4 sm:bottom-4 sm:p-6">
                <h2 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">{s.h1}</h2>
                <p className="mt-1 max-w-md text-sm text-slate-700">{s.needs[0]}.</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-700">Scopri la soluzione <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
